export enum DashboardApiTags {
  dashboard = "dashboard",
  widgetData = "widgetData",
}
